import CustomSpinner from "../../../../components/spinners/CustomSpinner"

// ** Reactstrap Imports
import { Input, Label, Button, Modal } from "reactstrap"

// ** Third Party Components
import * as yup from "yup"
import { useFormik } from "formik"
import Select from "react-select"

const catalogoMonedas = [
  {
    label: "MXN",
    value: "MXN"
  },
  {
    label: "USD",
    value: "USD"
  },
  {
    label: "CAD",
    value: "CAD"
  },
  {
    label: "EUR",
    value: "EUR"
  }
]
const LibertadFinancieraForm = (props) => {
  // ** State

  const datosAsesoria = {
    motivoAhorro: "",
    montoAhorro: "",
    plazo: "",
    moneda: "",
    instrumentoAhorro: "",
    rendimiento: ""
  }

  function initialValues() {
    if (props.accion === 1) {
      return datosAsesoria
    } else {
      return props.data
    }
  }

  function validationSchema() {
    return {
      // origen: yup.string().required("Este campo es requerido."),
      // destino: yup.string().required("Este campo es requerido."),
      // numPasajeros: yup.number().min(1).required("Este campo es requerido."),
      // edadPasajero: yup.number().required("Este campo es requerido.")
    }
  }

  const formik = useFormik({
    initialValues: initialValues(),
    validationSchema: yup.object(validationSchema()),
    onSubmit: (data, { resetForm }) => {
      data = {
        ...data,
        accion: props.accion,
        tipo: "personal",
        nombre: "Libertad financiera",
        slug: "libertad-financiera"
      }
      props.administrar(data, props.handleSuccess)
      resetForm()
    }
  })

  return (
    <div>
      <Modal isOpen={props.loading}>
        <CustomSpinner />
      </Modal>
      <h1 className="mb-2 col-12 text-center">Libertad financiera</h1>
      <div className="mb-1">
        <Label className="form-label" htmlFor="motivoAhorro">
          ¿Cuál es el motivo por el que deseas ahorrar?
        </Label>
        <Input
          id="motivoAhorro"
          type="textarea"
          placeholder="Ingrese motivo"
          value={formik.values.motivoAhorro}
          onChange={(e) => {
            formik.setFieldValue("motivoAhorro", e.target.value)
          }}
        />
      </div>
      <div className="mb-1">
        <Label className="form-label" htmlFor="montoAhorro">
          ¿Que monto necesitas ahorrar?
        </Label>
        <Input
          id="montoAhorro"
          type="number"
          placeholder="Ingrese monto"
          value={formik.values.montoAhorro}
          onChange={(e) => {
            formik.setFieldValue("montoAhorro", e.target.value)
          }}
        />
      </div>
      <div className="mb-1">
        <Label className="form-label" htmlFor="plazo">
          ¿En cuantos años quieres hacerlo?
        </Label>
        <Input
          id="plazo"
          type="number"
          placeholder="Ingresa los años"
          value={formik.values.plazo}
          onChange={(e) => {
            formik.setFieldValue("plazo", e.target.value)
          }}
        />
      </div>
      <div className="mb-1">
        <Label className="form-label" htmlFor="moneda">
          ¿En que moneda?
        </Label>
        <Select
          className="react-select"
          classNamePrefix="select"
          defaultValue={catalogoMonedas[0]}
          options={catalogoMonedas}
          isClearable={false}
          value={
            formik.values.moneda != ""
              ? { label: formik.values.moneda, value: formik.values.moneda }
              : catalogoMonedas[0]
          }
          onChange={(e) => {
            formik.setFieldValue("moneda", e.value)
          }}
        />
      </div>
      <div className="mb-1">
        <Label className="form-label" htmlFor="instrumentoAhorro">
          ¿Qué instrumento de ahorro utilizas hoy?
        </Label>
        <Input
          id="instrumentoAhorro"
          type="text"
          placeholder="Ingresa instrumento de ahorro"
          value={formik.values.instrumentoAhorro}
          onChange={(e) => {
            formik.setFieldValue("instrumentoAhorro", e.target.value)
          }}
        />
      </div>
      <div className="mb-1">
        <Label className="form-label" htmlFor="rendimiento">
          ¿Qué rendimiento te ofrece?
        </Label>
        <Input
          id="rendimiento"
          type="text"
          placeholder="Ingresa rendimiento"
          value={formik.values.rendimiento}
          onChange={(e) => {
            formik.setFieldValue("rendimiento", e.target.value)
          }}
        />
      </div>

      <div className="mt-3 d-flex justify-content-end">
        <Button className="m-1" color="primary" onClick={formik.handleSubmit}>
          {props.accion === 1 ? "Guardar" : "Guardar cambios"}
        </Button>
      </div>
    </div>
  )
}

export default LibertadFinancieraForm
